<template>
    <div class="outer">
        <div class="topSearch">
            <el-form class="queryRow" inline>
                <el-form-item label="货物分类" class="queryCol">
                    <el-cascader
                    style="width: 100%"
                    v-model="queryForm.goodsClassCode"
                    :props="{ label:'goodsClassName',value: 'goodsClassCode', emitPath: false, checkStrictly: true }"
                    :options="classOptions"
                    @change="onSearch"
                    clearable
                    @clear="onSearch">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="货物名称" class="queryCol">
                    <el-input placeholder="请输入" clearable @clear="onSearch" v-model="queryForm.goodsName"></el-input>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table
        v-loading="loading"
        ref="tableRef"
        class="table"
        :row-style="{ height: '50px' }"
        style="width: 100%; height: 60vh; overflow: auto;"
        :data="tableData">
            <el-table-column
                label="选择"
                v-if="claimDialogType === 'add'"
                width="55">
                <template slot-scope="scope">
                    <el-popover
                    v-if="scope.row.overSelect"
                    placement="top-start"
                    width="30"
                    trigger="hover"
                    content="已在申领的货物列表中">
                        <i slot="reference"  class="el-icon-success" style="color: #67C23A; font-size: 18px;"></i>
                    </el-popover>
                    <el-checkbox v-else v-model="scope.row.checked" :disabled="scope.row.goodsName.includes('充值卡')"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="货物名称"
                prop="goodsName">
            </el-table-column>
            <el-table-column
                align="center"
                label="仓库分类"
                prop="category">
                <template slot-scope="scope">
                    行政仓库
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="货物分类"
                prop="goodsClassName">
            </el-table-column>
            <el-table-column
                align="center"
                label="货物型号"
                prop="goodsType">
            </el-table-column>
            <el-table-column
                align="center"
                label="货物配置"
                prop="goodsConfig">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top" width="300">
                        <p>{{ scope.row.goodsConfig }}</p>
                            <div slot="reference">
                            <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                        </div>
                    </el-popover>        
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="平均价格(元)"
                prop="price">
            </el-table-column>
            <el-table-column
                align="center"
                label="总数量"
                prop="goodsNum">
            </el-table-column>
            <el-table-column
                align="center"
                label="货物单位"
                prop="goodsUnit">
            </el-table-column>
            <el-table-column
                align="center"
                v-if="claimDialogType === 'edit'"
                label="选择"
                prop="operate">
                <template slot-scope="scope">
                    <el-popover
                    v-if="scope.row.overSelect"
                    placement="top-start"
                    width="30"
                    trigger="hover"
                    content="已在申领的货物列表中">
                        <i slot="reference"  class="el-icon-success" style="color: #67C23A; font-size: 18px;"></i>
                    </el-popover>
                    <el-button type="text" v-else icon="el-icon-position"  @click="selectOnce(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :total="total"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :current-page="page"
            background
            layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
        
        <div class="dialog-footer" style="display: flex; justify-content: flex-end; margin-top: 10px;" v-if="claimDialogType === 'add'">
            <el-button type="primary" @click="submitAddInventory">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { getGoodsClassList } from '@/api/goods/goodsBusiness.js';
import { queryWarehouse } from '@/api/goods/inventory.js';
export default {
   data() {
    return {
        total: 0, // 总条目数
        pageSize: 10,
        page: 1,
        tableData: [],
        loading: false,
        queryForm: {
            category: '商务',
        },
        classOptions:[],
    }
   },
   async created(){
        await this.getGoodsClassLists();
        await this.getTableData();
   },
   computed:{
        
   },
   props: {
      checkedList: {
        type: Array,
      },
      claimDialogType: {
        type: String,
      }
    },
   methods:{
    // 选择单个货物
    selectOnce(row){
        let rowData = {...row};
        rowData.storeGoodsNum = rowData.goodsNum;
        
        this.$prompt(`请输入申领数量(库存总数量: ${ rowData.storeGoodsNum })`, '填写申领数量', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'number',
            inputValidator: (value) => {
                if (!value) {
                    return '请输入申领数量';
                }
                if(value > rowData.storeGoodsNum){
                    return '申领数量大于库存总数量';
                }
            }
        }).then(({ value }) => {
            rowData.goodsNum = Number(value);
            this.$emit('addInventory',[rowData]);
        })
    },
    // 提交添加库存
    submitAddInventory(){
        let selectionList = []; // 选择的库存中货物
        this.tableData.forEach(item => {
            if(item.checked) {
                let newItem = {...item};
                newItem.storeGoodsNum = item.goodsNum;
                newItem.goodsNum = 1;
                selectionList.push(newItem);
            }
        })
        if(selectionList.length === 0){
            this.$message({
                type:'error',
                message: '未选择新的货物'
            });
            return;
        }
        this.$emit('addInventory',selectionList);
    },
    // 获取货物类别列表
    async getGoodsClassLists(){
        await getGoodsClassList({classFlag: "2"}).then(res => {
            if(res.code === 200){
                this.classOptions = res.data;
            }
        })
    },
    // 当每页条数变化
    onSizeChange(e){
        this.page = 1;
        this.pageSize = e;
        this.getTableData();
    },
    // 搜索
    onSearch(){
        this.page = 1;
        this.getTableData();
    },
    // 当页码发生变化时
    onCurrentChange(e){
        this.page = e;
        this.getTableData();
    },
    // 获取表格数据
    async getTableData(){
        this.loading = true;
        await queryWarehouse({
            page: this.page,
            limit: this.pageSize,
            goodsName: this.queryForm.goodsName,
            category: '行政',
            goodsClassCode: this.queryForm.goodsClassCode,
        }).then(res => {
            if(res.code === 200){
                this.total = res.total;
                this.tableData = res.data.map((item,i) => {
                    this.checkedList.forEach((jtem) => {
                        if(jtem.goodsCode === item.goodsCode){
                            item.overSelect = true;
                        }
                    })
                    return item;
                });

                this.loading = false;
            }
        })
    }
   }
}
</script>
<style lang="scss" scoped>
.outer{

    ::v-deep .el-descriptions-item{
        font-size: 16px;
    }

    .el-form-item{
        margin-right: 20px;
    }
    .pageination{
        display: flex; 
        justify-content: flex-end;
        margin-top: 5px
    }
    .topSearch{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }
    .detailTable{
        ::v-deep .el-checkbox__input{
            &.is-checked{
                .el-checkbox__inner{
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .el-table{
        ::v-deep .warning-row{
            display: none;
        }
    }
    .table{
        &::before{
            display: none;
        }
        
        ::v-deep .el-table__cell{
            >:empty::before{
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
